import { Component } from '@angular/core';

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {}



// WEBPACK FOOTER //
// ./src/app/common/other/spinner/spinner.component.ts